

















































































import { Component, Watch } from 'vue-property-decorator';
import Farm from '@/core/interfaces/Farm';
import { Action, Getter } from 'vuex-class';
import Vehicle from '@/core/interfaces/Vehicle';
import FormFooter from '@/components/FormFooter.vue';
import FormBase from '@/mixins/FormBase';
import VehicleType from '@/core/interfaces/VehicleType';
import AvailableVehicleType from '@/core/interfaces/AvailableVehicleType';
import TimeZone from '@/core/interfaces/TimeZone';
import Locale from '@/core/interfaces/Locale';
import FarmGroup from '@/core/interfaces/FarmGroup';
import User from '@/core/interfaces/User';
import UserGroup from '@/core/interfaces/UserGroup';
import arrayUnique from 'array-unique';
import Module from '@/core/interfaces/Module';
import RelayServer from '@/core/interfaces/RelayServer';
import TagSelect from '@/components/TagSelect.vue';

@Component({
    components: { TagSelect, FormFooter },
})
export default class FarmForm extends FormBase<Farm> {
    @Getter('vehiclesByFarm')
    vehiclesByFarm!: (id: number) => Vehicle[];

    @Getter('vehicleTypesByFarm')
    vehicleTypesByFarm!: (id: number) => VehicleType[];

    @Getter('availableVehicleTypesByFarm')
    availableVehicleTypesByFarm!: (id: number) => AvailableVehicleType[];

    @Getter('vehicleTypes')
    vehicleTypes!: VehicleType[];

    @Getter('timeZones')
    timeZones!: TimeZone[];

    @Getter('locales')
    locales!: Locale[];

    @Getter('farmGroups')
    farmGroups!: FarmGroup[];

    @Getter('farmGroupsByFarm')
    farmGroupsByFarm!: (id: number) => FarmGroup[];

    @Getter('userGroupsByFarmGroup')
    userGroupsByFarmGroup!: (id: number) => UserGroup[];

    @Getter('usersByFarm')
    usersByFarm!: (id: number) => User[];

    @Getter('usersByUserGroup')
    usersByUserGroup!: (id: number) => User[];

    @Getter('modules')
    modules!: Module[];

    @Getter('relayServers')
    relayServers!: RelayServer[];

    @Action('saveFarm')
    saveAction!: (payload: Partial<Farm>) => Promise<Farm>;

    @Action('saveAvailableVehicleType')
    saveAvailableVehicleType!: (payload: Partial<AvailableVehicleType>) => Promise<void>;

    @Action('deleteAvailableVehicleType')
    deleteAvailableVehicleType!: (payload: number) => Promise<void>;

    name = '';

    codeName = '';

    sim = false;

    movexNumber = '';

    license = '';

    timezoneId = 0;

    localeId = 0;

    farmGroupIds: number[] = [];

    saving = false;

    moduleIds: number[] = [];

    isFactory = false;

    relayServerId: number | null = null;

    @Watch('initial', { immediate: true })
    setFromInitial(): void {
        if (!this.initial) {
            return;
        }

        this.name = this.initial.name || '';
        this.codeName = this.initial.code_name || '';
        this.license = this.initial.farm_license || '';
        this.timezoneId = this.initial.timezone_id || 1;
        this.localeId = this.initial.locale_id || 1;
        this.moduleIds = this.initial.module_ids || [];
        this.movexNumber = this.initial.movex_number || '';
        this.sim = this.initial.sim || false;
        this.isFactory = this.initial.is_factory || false;
        this.relayServerId = this.initial.relay_server_id || null;
        this.setDefaultRelayServer();
    }

    @Watch('relayServerOptions')
    setDefaultRelayServer(): void {
        if (!this.exists && this.relayServerId === null && this.relayServerOptions.length) {
            this.relayServerId = this.relayServerOptions[0].id;
        }
    }

    @Watch('initialFarmGroupIds', { immediate: true })
    setFarmGroupIds(): void {
        this.farmGroupIds = this.initialFarmGroupIds;
    }

    get initialFarmGroupIds(): number[] {
        return this.initial.id ? this.farmGroupsByFarm(this.initial.id).map(group => group.id) : [];
    }

    async afterSave(farm: Farm): Promise<void> {
        await this.$store.dispatch('saveFarmGroupsByFarm', {
            farmId: farm.id,
            farmGroupIds: this.farmGroupIds,
        });
    }

    get parseForm(): Partial<Farm> {
        return {
            id: this.initial?.id || undefined,
            name: this.name,
            code_name: this.codeName,
            farm_license: this.license,
            timezone_id: this.timezoneId,
            locale_id: this.localeId,
            module_ids: this.moduleIds,
            movex_number: this.movexNumber,
            sim: this.sim,
            is_factory: this.isFactory,
            relay_server_id: this.relayServerId as number,
        };
    }

    get vehicles(): Vehicle[] {
        if (!this.initial?.id) {
            return [];
        }

        return this.vehiclesByFarm(this.initial.id);
    }

    get users(): User[] {
        return arrayUnique(
            [
                ...this.initial?.id ? this.usersByFarm(this.initial.id) : [],
                ...this.farmGroupIds
                    .flatMap(farmGroupId => this.userGroupsByFarmGroup(farmGroupId))
                    .flatMap(userGroup => this.usersByUserGroup(userGroup.id)),
            ],
        ).sort((a, b) => a.username.localeCompare(b.username));
    }

    get relayServerOptions(): { id: number; label: string }[] {
        return this.relayServers.map(server => ({
            id: server.id,
            label: `${server.hostname} (${server.protocol})`,
        }));
    }
}

